// edit-item-modal.component.ts
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AddNewUserService } from '../services/add-new-user.service'
@Component({
  selector: 'app-edit-user-modal',
  templateUrl: './edit-user-dialog.component.html'
})
export class EditItemModalComponent {
  @Input() row: any;
  isSaving: boolean = false;
  constructor(private addNewUserService: AddNewUserService, public activeModal: NgbActiveModal) { }

  save() {
    this.isSaving = true;
    // Logic to save data
    this.addNewUserService.updateUser(this.row).subscribe(
      (response) => {
        this.isSaving = false;
        console.log(response);
        this.activeModal.close('saved'); 
      },
      (error) => {
        console.log(error);
      }
    );
    console.log('Saving data', this.row);
  }

  close() {
    this.activeModal.close('closed');
  }

}
